import { debounce } from '../utils';
import cpoVideoUrls from './cpoVideoUrls.json';
function controller (
    listingService, $sce, photoLightboxService, modalService, $document, $scope, $timeout,
    tabService, als, $interval, $window, viewport, adService, pageStateService, $log
) {
    let photoLightboxImagesElement, interval, lightboxTabs;

    const ctrl = this;
    ctrl.$onInit = handleOnInit;
    ctrl.$onDestroy = handleOnDestroy;
    ctrl.thumbnailView = false;

    viewport.onChange(_viewportChangeHandler);

    ctrl.closeLightbox = function () {
        adService.seekAndDestroySlots(ctrl.adSlot)
            /* prevent unforseen gpt.js issues from preventing us from closing the photo lightbox */
            .catch(err => $log.warn(err))
            .finally(() => {
                modalService.get('photoLightbox').toggle();
                if (angular.element($window.document.getElementById('video-js'))) {
                    angular.element($window.document.getElementById('video-js')).attr('src', '');
                }
                pageStateService.pop('page.pageInfo.pageName', false);
                pageStateService.pop('page.pageInfo.channel', false);
            });
    };

    ctrl.toggleGridView = () => ctrl.thumbnailView = !ctrl.thumbnailView;

    function handleOnInit () {
        ctrl.$sce = $sce;
        ctrl.photoLightboxService = photoLightboxService;
        ctrl.tabService = tabService;
        ctrl.currentPhotoIndex = 1;
        // Pulled from static as is...
        ctrl.views360 = ctrl.spinCar ? true : null;
        _viewportChangeHandler();

        const tabOptions = photoLightboxService.getOptions();
        interval = $interval(() => {
            lightboxTabs = tabService.getCollection('lightbox');
            let defaultTab = lightboxTabs && lightboxTabs.get(tabOptions.tabId);

            if (!defaultTab) {
                $interval.cancel(interval);
                ctrl.isDefaultTabResolved = true;
            } else if (defaultTab.isOpenOnTop()) {
                $interval.cancel(interval);
                ctrl.isDefaultTabResolved = true;
            } else {
                lightboxTabs.closeAll();
                defaultTab.open();
                $interval.cancel(interval);
                ctrl.isDefaultTabResolved = true;
                photoLightboxService.setBodyScroll();
            }
        }, 10);

        $timeout(_initAds, 0);

        listingService.getListing()
            .then(listingResponse => {
                const listing = listingResponse.listingDetailDto;

                ctrl.sponsoredVideos = listingResponse.sponsoredVideos;
                ctrl.listing = listing;
                ctrl.videoUrl = photoLightboxService.getVideoUrl(listing.videoUrl || '');

                ctrl.hasCpoVideo = (listing.isCpoVehicle && cpoVideoUrls[listing.makeName.replace('-','_').toLowerCase()]) ? cpoVideoUrls[listing.makeName.replace('-', '_').toLowerCase()] : false;
                ctrl.ad = photoLightboxService.getAd(ctrl.listing);

                fireAlsImpression(listing);
                $timeout(() => {
                    photoLightboxImagesElement = angular.element($document[0].getElementsByClassName('photo-lightbox__images'));
                    photoLightboxImagesElement.on('scroll', debouncedImageScrollHandler);

                    addPageStateUpdateToCheckAvailabilityButton('check-availability-btn');
                }, 1000);
            });
    }
    /* istanbul ignore next */
    function addPageStateUpdateToCheckAvailabilityButton(id) {
        let getCheckAvailabilityBtn = $window.document.getElementById(id);
        if (getCheckAvailabilityBtn) {
            getCheckAvailabilityBtn.addEventListener('click', function () {
                pageStateService.pop('page.pageInfo.pageName', false);
                pageStateService.pop('page.pageInfo.channel', false);

                pageStateService.push('page.pageInfo.pageName', 'leads/emailLeadForm', false);
                pageStateService.push('page.pageInfo.channel', 'leads', false);
                pageStateService.push('event', { eventName: 'lead' }, true);
            });
        }
    }

    function handleOnDestroy () {
        $interval.cancel(interval);

        if (lightboxTabs) {
            lightboxTabs.closeAll();
        }

        return photoLightboxImagesElement && photoLightboxImagesElement.unbind('scroll', debouncedImageScrollHandler);
    }

    function fireAlsImpression (data) {
            const alsObj = _buildAlsImpression(data);
            als.impression(alsObj);
    }

    function _buildAlsImpression (listing) {
        const alsKeys = [ "affiliateAgentId", "listingId", "localOfferId", "makeId", "modelId",
            "modelYearId", "primaryFeedSourceId", "sellerId", "stockTypeCode", "trimId" ];
        let alsObj = { pageToName: _getPageToName() };
        alsKeys.forEach(k => alsObj[k] = listing[k]);
        return alsObj;
    }

    function _getPageToName () {
        const plbOptions = photoLightboxService.getOptions();
        return /video/i.test(plbOptions.tabId) ? "vdpVideoPlay" : "vdpPhotoLightBox";
    }

    /* istanbul ignore next */
    function _getAdSize () {
        const dealerInfoEl = $document[0].querySelector('.photo-lightbox__dealer-info');
        const boundingRect = dealerInfoEl ? dealerInfoEl.getBoundingClientRect() : {bottom: 99999};
        return window.innerHeight - boundingRect.bottom - 24 >= 600 ? 'cube-vdp' : 'cube';
    }

    function _initAds() {
        ctrl.adSize = _getAdSize();
        ctrl.showRightRailAd = true;
    }

    function _viewportChangeHandler () {
        ctrl.isAtLeastDesktop = viewport.isAtLeastDesktop();
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////

    let debouncedImageScrollHandler = debounce(imageScrollHandler, 50);

    function imageScrollHandler () {
        const images = angular.element(this).find('img');

        for (let i = 0; i < images.length; i++) {
            const boundingRect = images[i].getBoundingClientRect();

            if (boundingRect.top >= 0) {
                ctrl.currentPhotoIndex = i + 1;
                $scope.$digest();

                return false;
            }
        }
    }
}

controller.$inject = [
    'listingService',
    '$sce',
    'photoLightboxService',
    'modalService',
    '$document',
    '$scope',
    '$timeout',
    'tabService',
    'alsService',
    '$interval',
    '$window',
    'viewport',
    'adService',
    'pageStateService',
    '$log'
];

export default controller;
